import { InternalSessionState } from './session-controller.enums';
export { InternalSessionState } from './session-controller.enums';
export var INITIAL_STATES = [
    InternalSessionState.Initialized,
    InternalSessionState.Loading
];
export var FINAL_STATES = [
    InternalSessionState.Stopping,
    InternalSessionState.Stopped,
    InternalSessionState.Finished
];

//# sourceMappingURL=internal-session-state.js.map